<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-textbox-control displayName="Name" description="Provide the reference file name." [control]="formGroup.controls.name" />
    <unity-file-uploader-control
      displayName="Attach File"
      description="Upload a PDF file from your computer to use as a reference on this agreement."
      [control]="formGroup.controls.upload_id"
      [allowedExtensions]="['.pdf']" />
  </unity-card-new-shared>
</unity-page-container>
